module.exports = __webpack_public_path__ + "img/10.0800514a.png";